import { selector } from "recoil"
import layoutState from "../../atoms/layout"
import { badgeHistoryListSelector } from "../../atoms/badgeHistory"
import { localUserIdAtom, usersSelector } from "../../atoms/users"
import { hasPermission } from "../../../util"
import { roomSelector } from "../../atoms/room"
import { shoppableVideosSelector } from "../shoppable-videos-selector"
import { shoppableVideosListSelector } from "../../atoms/shoppableVideos"
import { someHaveOnDeviceSelector } from "../../selectors/some-have-on-selectors"
import { shoppableMNPVideoAtom } from "../../atoms/shoppableVideos"
const UserPermission = window.MeetOnline?.UserPermission

export const mobileChatTabSelector = selector<boolean>({
  key: "mobileChatTabSelector",
  get: ({ get }) => {
    const tabIndex = get(layoutState.historyTabEnabledMobile)

    const userId = get(localUserIdAtom)
    const localUser = get(usersSelector(userId))
    return (
      tabIndex === 0 &&
      localUser &&
      (hasPermission(localUser.permissions, UserPermission.canUseChat) ||
        localUser.type === 3)
    )
  }
})

export const mobileHistoryBadgesTabSelector = selector<boolean>({
  key: "mobileHistoryBadgesTabSelector",
  get: ({ get }) => {
    const tabIndex = get(layoutState.historyTabEnabledMobile)
    const badgesHistory = get(badgeHistoryListSelector)
    const userId = get(localUserIdAtom)
    const localUser = get(usersSelector(userId))
    return (
      tabIndex === 2 &&
      (badgesHistory.length > 0 ||
        localUser?.type === 3 ||
        get(shoppableMNPVideoAtom).enabledShoppableMNP)
    )
  }
})

export const mobileVideosTabSelector = selector<boolean>({
  key: "mobileVideosTabSelector",
  get: ({ get }) => {
    const tabIndex = get(layoutState.historyTabEnabledMobile)
    const userId = get(localUserIdAtom)
    const localUser = get(usersSelector(userId))

    return (
      tabIndex === 1 &&
      ((get(shoppableVideosSelector) &&
        get(shoppableVideosListSelector).length !== 0) ||
        localUser.type === 3)
    )
  }
})

export const chatInputBoxOverlaySelector = selector<boolean>({
  key: "chatInputBoxOverlaySelector",
  get: ({ get }) => {
    const isChatInputBox = get(roomSelector).chatInputBoxOverlay
    return get(layoutState.activeTab) === "chat" && isChatInputBox
  }
})
